import { render } from "./navbarblog.vue?vue&type=template&id=d645a9fc"
import script from "./navbarblog.vue?vue&type=script&lang=js"
export * from "./navbarblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__